import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';
import { RestService } from './rest.service';
import { map, tap } from "rxjs/operators";
import { catchError } from "rxjs/operators"
import { RecordXml } from '../models/RecordXML';

@Injectable()
export class RecordXmlService extends RestService<RecordXml> {
    constructor(http: Http) {
        super(`${environment.apiEndpoint}/api/RecordsXml`, http);
    }

    getAllFromCompany(companyId: string): Observable<RecordXml[]> {
        return this.http
            .get(`${environment.apiEndpoint}/api/RecordsXml` + this.getAccessToken() + "&companyId=" + companyId)
            .pipe(map((res: Response) => <RecordXml[]>res.json()));
    }
}